import React from 'react';

import Label from '@components/formItem/FormLabel';

import PropTypes from 'prop-types';

function ColumnTitle({ text, tip, subText, className, isRequired, style }) {
  return (
    <div style={style} className={`col-title ${className}`}>
      {tip ? (
        <Label
          text={text}
          subText={subText}
          tip={tip}
          className={`${className} ${isRequired ? 'is-required' : ''}`}
        />
      ) : (
        <span className={isRequired ? 'is-required' : ''}>{text}</span>
      )}
    </div>
  );
}

ColumnTitle.defaultProps = {
  tip: '',
  isRequired: false,
  className: '',
};

ColumnTitle.propTypes = {
  text: PropTypes.string.isRequired,
  tip: PropTypes.any,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
};

export default ColumnTitle;
